var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"primary",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.onClick($event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-location-enter")]),(_vm.coinFee > 0)?_c('span',[_vm._v(_vm._s(_vm.$t("common.buy-in-and-participate")))]):_c('span',[_vm._v(_vm._s(_vm.$t("publicGame.participate")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }